<template>
  <div>
    <h2 class="mb-4">{{ $t('ARTWORK_UPLOAD.UPLOAD_REVIEW')}}</h2>
    <p v-html="$t('ARTWORK_UPLOAD.UPLOAD_REVIEW_MSG')"></p>
    <div v-if="errorMessage" class="error--text">{{errorMessage}}</div>
    <v-layout row wrap mt-4>
      <v-flex>
        <tk-btn flat @click="$emit('prev')">{{ $t('COMMON.BACK') }}</tk-btn>
      </v-flex>

      <v-flex text-xs-right>
        <tk-btn :loading="saving" flat @click="saveAndReturn">{{ $t('COMMON.SAVE_RETURN') }}</tk-btn>
        <tk-btn
          color="primary"
          :loading="saving"
          @click="publish"
        >{{ $t('ARTWORK_UPLOAD.PUBLISH') }}</tk-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/services/RepositoryFactory";
import { ErrorHandler } from "@/utils/ErrorHandler";

const handler = new ErrorHandler();
const artworksRepo = RepositoryFactory.artworks();

export default {
  props: ["artwork"],

  data() {
    return {
      saving: false,
      errorMessage: ''
    };
  },

  methods: {
    async publish() {
      this.saving = true;

      try {
        await artworksRepo.publishArtwork(this.artwork.id);
        await this.$auth.refresh();
        this.$router.replace({ name: "profile.artworks" });
      } catch (error) {
        this.$emit("error", "step4");
        const errors = error.data.errors;
        this.errorMessage = errors && errors.artworks && errors.artworks[0]
      }

      this.saving = false;
    },

    saveAndReturn() {
      if (this.artwork.isPublished) {
        this.$router.push({ name: "profile.artworks" });
      } else {
        this.$router.push({ name: "profile.artworks.draft" });
      }
    }
  }
};
</script>
